<template>
  <div class="tree_content">
    <div class="tree_item">
      <span class="tree_item_title">
        <img :src="qiyeIcon" class="title_icon">
        {{data[0].corpName}}
      </span>
      <template v-if="data&&data.length>0">
         <div v-for="item in data" :key="item.id" class="tree_item_child" @click="handleClick(item)">
           <span :class="{'active_item':select===item.id}">{{`${item.carrierTenantName}  (${item.customerName})`  }}</span>
         </div>
      </template>
      
    </div>
  </div>
</template>

<script>
import qiyeIcon from '@/assets/img/auth/icon_qi_circle.png'

  export default {
    name:'CarrierTree',
    props:{
      data:{
        type:Array,
        default:()=>([])
      },
      defaultCarrier:{
        type:String,
        default:()=>('')
      }
    },
    data(){
      return{
      qiyeIcon,
      select:'',
      }
    },
    created(){
      this.select=this.defaultCarrier
    },
    methods:{
      handleClick(child){
        this.select=child.id
        this.$emit('select',child)
      }
    }
  }
</script>

<style lang="less" scoped>
.tree_content {
  width: 300px;
  .tree_item {
    // border-left: 1px solid #ccc;
    .tree_item_title {
      color: #323233;
      display: block;
      position: relative;
      padding-left: 18px;
      .title_icon {
        width: 26px;
        height: 26px;
        position: absolute;
        left: -11px;
        top: -3px;
        z-index: 100;
      }
    }
    .tree_item_child {
      position: relative;
      padding: 16px 20px;
      border-left: 1px solid #EBEDF0 ;
      cursor: pointer;
      &:hover{
        color: #68D2B1;
      }
      &:focus{
        color: #059C6C;
      }
      &::before{
        content: '';
        height: 1px;
        width: 20px;
        background: #EBEDF0 ;
        display: block;
        position: absolute;
        top: 94%;
        left: 0;
      }
      span{
        position: absolute;
        bottom: -8px;
        margin-left: 10px;
      }
    }
  }
}
.active_item {
  color: #06B880;
}
</style>